module.exports = __webpack_public_path__ + "static/media/validacao_email_dark.380ef4c9.svg";